import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserPreferences {
  theme: 'default' | 'dark';
  soundEnabled: boolean;
  animationsEnabled: boolean;
  boardTheme: string;
  pieceTheme: string;
  autoPromoteToQueen: boolean;
  showLegalMoves: boolean;
  showCoordinates: boolean;
}

interface UserStore {
  playerId: string | null;
  playerName: string;
  preferences: UserPreferences;
  
  // Actions
  setPlayerId: (id: string) => void;
  setPlayerName: (name: string) => void;
  updatePreferences: (prefs: Partial<UserPreferences>) => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      playerId: null,
      playerName: '',
      preferences: {
        theme: 'default',
        soundEnabled: true,
        animationsEnabled: true,
        boardTheme: 'default',
        pieceTheme: 'default',
        autoPromoteToQueen: false,
        showLegalMoves: true,
        showCoordinates: true,
      },
      
      setPlayerId: (id) => set({ playerId: id }),
      
      setPlayerName: (name) => set({ playerName: name }),
      
      updatePreferences: (prefs) => set((state) => ({
        preferences: { ...state.preferences, ...prefs }
      })),
    }),
    {
      name: 'chess-user-preferences',
      partialize: (state) => ({ 
        playerName: state.playerName,
        preferences: state.preferences 
      }),
    }
  )
);